var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-in-up"}},[_c('v-container',{staticClass:"service-form-template custom-border-grey-dashed",class:{
      'pointer-events-none': !_vm.getPermission('service-form:update'),
    },attrs:{"fluid":"","id":"service-form"}},[_c(_vm.getComponent,{tag:"component",attrs:{"detail":_vm.detail,"serviceForm":_vm.serviceForm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }